module.exports = __webpack_public_path__ + "img/RIcon.0b72ae29.svg";